import React, { useState } from 'react'
import { Text } from '@crossfit/ui'

import { Invitation } from 'types'
import * as affiliatesService from 'services/affiliates'
import { useNotification } from 'components/Notification'
import { Menu, MenuButton } from '../Menu'
import RevokeInvite from './RevokeInvite'
import { useMediaQuery } from 'hooks/useMediaQuery'
import { UserList, UserListItem } from 'components/Admin/Shared/UserList'
import { useMutation } from 'react-query'
import { useAffiliate } from 'hooks/useAffiliate'

type InvitationListItemProps = {
  invitation: Invitation
  isMobile: boolean
}

function InvitationListItem({ invitation, isMobile }: InvitationListItemProps) {
  const { email, name, roles, certifications, token } = invitation
  const { selectedAffiliate: affiliate } = useAffiliate()
  const showNotification = useNotification()
  const [showRevokeInvite, setShowRevokeInvite] = useState(false)
  const resendInvite = useMutation(affiliatesService.resendInvite)

  async function handleResendInvite() {
    await resendInvite.mutateAsync({ affiliateId: affiliate?.id, token })
    showNotification(`Successfully resent invite to ${email}`)
  }

  return (
    <>
      {showRevokeInvite && (
        <RevokeInvite
          invitation={invitation}
          onClose={() => setShowRevokeInvite(false)}
        />
      )}
      <UserListItem
        isMobile={isMobile}
        name={name}
        email={email}
        certifications={certifications}
        roles={roles}
        menu={
          <Menu>
            <MenuButton
              onClick={handleResendInvite}
              disabled={resendInvite.isLoading}
            >
              Resend Invite
            </MenuButton>
            <MenuButton
              onClick={() => setShowRevokeInvite(true)}
              variant='destructive'
            >
              Revoke Invite
            </MenuButton>
          </Menu>
        }
      />
    </>
  )
}

function InvitationsTable() {
  const isMobile = useMediaQuery(`(max-width: 767px)`)
  const { invitations } = useAffiliate()
  return (
    <>
      {invitations.length > 0 ? (
        <UserList isMobile={isMobile}>
          {invitations.map((invitation) => (
            <InvitationListItem
              key={invitation.id}
              invitation={invitation}
              isMobile={isMobile}
            />
          ))}
        </UserList>
      ) : (
        <Text mb={12}>No invites are currently pending.</Text>
      )}
    </>
  )
}

export default InvitationsTable
